module.exports = __webpack_public_path__ + "img/_54A2239.277d3a46.jpg";